module.exports = __webpack_public_path__ + "static/2022-ruby-on-rails-survey-results-b7bbb0d7c1f97f1dbd6a459aa9167def.png";